import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';
import { createReduceObject as createListsCollectionReduceObject } from '../../../../../common/reducers/listsCollection/reducer';

import taskGetByIdSaga from './sagas/taskGetByIdSaga';
import tasksToExecutorsCollectionRefreshItemSaga from './sagas/tasksToExecutorsCollectionRefreshItemSaga';
import tasksGeoTargetAccessesSaga from './sagas/tasksGeoTargetAccessesSaga';
import tasksExecsCollectionSaga from './sagas/tasksExecsCollectionSaga';
import tasksExecLogCollectionSaga from './sagas/tasksExecLogCollectionSaga';
import tasksExecsNotSendMaterialsCollectionSaga from './sagas/tasksExecsNotSendMaterialsCollectionSaga';

export default [
  ...createCombineMapItem(
    'tasksCollection',
    createObjectCollectionReduceObject,
    [taskGetByIdSaga]
  ),
  ...createCombineMapItem(
    'tasksToExecutorsCollection', // Коллекция моделей заданий для исполнителей
    createObjectCollectionReduceObject,
    [tasksToExecutorsCollectionRefreshItemSaga]
  ),
  ...createCombineMapItem(
    'tasksGeoTargetAccessesCollection',
    createObjectCollectionReduceObject,
    [tasksGeoTargetAccessesSaga]
  ),
  ...createCombineMapItem(
    'tasksExecsCollection',
    createObjectCollectionReduceObject,
    [tasksExecsCollectionSaga]
  ),
  ...createCombineMapItem(
    'tasksExecLogCollection',
    createListsCollectionReduceObject,
    [tasksExecLogCollectionSaga]
  ),
  ...createCombineMapItem(
    'tasksExecsNotSendMaterialsCollection',
    createListsCollectionReduceObject,
    [tasksExecsNotSendMaterialsCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/collections/reducersMap.js